import { FC } from "react";

import { serverStartRecordingSession, serverStopRecordingSession } from "api/api-server-actions";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { MenuItem } from "mds/components/Menu";
import { RecordingIcon, RecordingStopIcon } from "mds/icons";

type StartRecordingMenuItemProps = {
  courseId: string;
};

export const StartRecordingMenuItem: FC<StartRecordingMenuItemProps> = ({ courseId }) => {
  const onStartRecording = async () => {
    await serverStartRecordingSession(courseId);
  };

  return (
    <MenuItem eventName="Start Recording" onClick={onStartRecording}>
      <IconText iconStart={<RecordingIcon />} text={t("recording_controls.start_recording")} />
    </MenuItem>
  );
};

type StopRecordingMenuItemProps = {
  recordingSessionId: string;
};

export const StopRecordingMenuItem: FC<StopRecordingMenuItemProps> = ({ recordingSessionId }) => {
  const onStopRecording = async () => {
    await serverStopRecordingSession(recordingSessionId);
  };

  return (
    <MenuItem eventName="Stop Recording" onClick={onStopRecording}>
      <IconText iconStart={<RecordingStopIcon />} text={t("recording_controls.stop_recording")} />
    </MenuItem>
  );
};
